import { render, staticRenderFns } from "./CpuModelDetailModal.vue?vue&type=template&id=267882d2&scoped=true"
import script from "./CpuModelDetailModal.vue?vue&type=script&lang=js"
export * from "./CpuModelDetailModal.vue?vue&type=script&lang=js"
import style0 from "./CpuModelDetailModal.vue?vue&type=style&index=0&id=267882d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267882d2",
  null
  
)

export default component.exports